// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './directives';
export * from './form-card';
export * from './form.module';
// @endindex